<template>
  <div class="sd-manual">
    <router-view @product-model="emitProductModel" @current-tutorial="emitCurrentTutorial"></router-view>
  </div>
</template>

<script>
export default {
  name: 'sdManual',
  methods: {
    emitProductModel (data) {
      this.$emit('product-model', data)
    },
    emitCurrentTutorial (data) {
      this.$emit('current-tutorial', data)
    }
  }
};
</script>

<style lang="scss">
  @import './../styles/layout';
  @import './../styles/variables';

  ////////////
  // PRODUCT MANUAL
  ////////////

  .sd-manual {
    padding: 36px;
    background: white;
    box-shadow: inset 0 0 0 12px goldenrod, 0 0 0 100vmax goldenrod;
    &:after {
      content: '';
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: block;
      z-index: 2000;
      user-select: none;
      pointer-events: none;
      width: 100%;
      height: 100%;
      box-shadow: inset 0 0 0 12px goldenrod, 0 0 0 100vmax goldenrod;
    }
  }
  .sd-product-manual {
    position: relative;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    height: calc(100vh - 72px);
    padding: 18px 12px;
    background: map_get($colors, lightGold);
    @media all and (min-width: $sd-vw_sm) {
      position: static;
      display: grid;
      grid-auto-flow: row;
      grid-template-columns: 40% 60%;
      grid-auto-rows: auto;
      grid-row-gap: 36px;
      height: calc(100vh - 146px);
      padding: 0;
      background: none;
    }
  }
  .sd-product-manual__content {
    z-index: 1;
    flex: 1 1 100%;
    grid-row: 1 / 3;
    height: auto;
    align-self: stretch;
    display: flex;
    flex-flow: column nowrap;
    justify-content: stretch;
    align-items: flex-start;
    order: 3;
    position: sticky;
    bottom: 0;
    margin: 36px -24px 12px;
    padding: 24px 24px 18px;
    @media all and (max-width: #{$sd-vw_sm - 1}) {
      position: fixed;
      display: block;
      min-height: auto;
      max-height: 33vh;
      overflow-y: visible;
      bottom: 0;
      left: 24px;
      right: 24px;
      color: map_get($colors, white);
      background: map_get($colors, black);
      will-change: max-height;
      transition: max-height 0.33s ease-in-out;
      &.show-full-description {
        max-height: calc(100vh - 72px);
      }
    }
    @media all and (min-width: $sd-vw_sm) {
      position: unset;
      bottom: unset;
      order: unset;
      flex: 0 1 calc(40% - 48px);
      margin: unset;
      padding: unset;
      background: unset;
      margin-right: 24px;
    }
  }
  .sd-product-manual__diagram {
    align-self: stretch;
    flex: 1 0 calc(60% - 48px);
    grid-row: 1 / 3;
    grid-column: 2 / 3;
    height: 100%;
    max-height: calc(100vh - 184px);
    position: relative;
    display: flex;
    flex-flow: column nowrap;
    align-items: stretch;
    justify-content: space-between;
    order: 2;
    margin-bottom: 0;
    @media screen and (max-width: #{$sd-vw_sm - 1}) {
      transition: transform 0.33s ease-in-out;
      &.centered-diagram {
        transform: translateY(calc((50vh - 50%) / 2));
      }
    }
    @media all and (min-width: $sd-vw_sm) {
      background: map_get($colors, lightGold);
      box-shadow: 100vw 0 0 100vw map_get($colors, lightGold);
    }
    @media screen and (min-width: $sd-vw_md) {
      order: unset;
      flex-flow: row nowrap;
      align-items: center;
    }
  }

  .sd-product-manual__heading,
  .sd-product-manual__content-actions {
    flex: 0 0 auto;
  }
  .sd-product-manual__content-actions {
    width: auto;
  }
  .sd-product-manual__heading {
    z-index: 300;
    flex: 1 1 100%;
    grid-column: 1 / -1;
    grid-row: 1 / 2;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 36px;
    h3.s4_5vp {
      line-height: 1;
      margin-bottom: 12px;
    }
    order: 1;
    @media all and (min-width: $sd-vw_sm) {
      order: unset;
      flex-flow: row nowrap;
    }
  }
  .sd-product-manual__content-main {
    flex: 1 1 auto;
    position: relative;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-end;
    align-items: stretch;
    width: inherit;
    height: inherit;
    text-align: left;
    scroll-behavior: smooth;
    .sd-button,
    .sd-product-manual__content-main_heading {
      flex: 0 0 auto;
    }
    .sd-product-manual__content-main_heading {
      order: 2;
    }
    .sd-product-manual__content-actions {
      display: flex;
      flex-flow: row wrap;
      bottom: unset;
      margin-top: 12px;
      order: 3;
      position: relative;
      .sd-button-group {
        flex: 1;
        justify-content: flex-end;
      }
      .sd-button-group__left {
        & > * + * {
          margin-left: 0;
        }
      }
    }
    .description {
      order: 3;
      flex: 1 1 auto;
      min-height: fit-content;
      display: flex;
      flex-flow: column nowrap;
      justify-content: flex-start;
      align-content: stretch;
      padding-bottom: 12px;
    }
    @media all and (max-width: #{$sd-vw_sm - 1}) {
      .sd-product-manual__content-main_heading {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: baseline;
        h3 {
          flex: 1 1 auto;
        }
        .current-step {
          flex: 0 0 auto;
          line-height: 1;
        }
      }
      & h2.tutorial-target + p {
        margin-top: 0.5em;
      }
      & p + p {
        margin-top: 0.5em;
      }
      .sd-product-manual__content-actions {
        padding: unset;
        margin: unset;
        background: unset;
        position: absolute;
        top: 0;
        transform: translateY(calc(-100% - 6px));
        .sd-button {
          margin-bottom: 0;
        }
      }
    }
    @media all and (min-width: $sd-vw_sm) {
      width: 100%;
      .sd-product-manual__content-actions,
      .description,
      .sd-product-manual__content-main_heading {
        order: unset;
      }
      .description {
        padding-bottom: 0;
      }
      .sd-product-manual__content-actions {
        left: unset;
        right: unset;
        margin-top: unset;
      }
    }
  }
  .sd-product-manual__content-main_heading {
    position: relative;
    padding-bottom: 12px;
    & > * {
      line-height: 1;
      display: inline;
      flex: 0 0 auto;
    }
    & > * + * {
      margin-left: 12px;
    }
    .current-step {
      order: 2;
      width: auto;
    }
    .numerator, .denominator {
      font-size: 0.7em;
      font-weight: 400;
    }
    .tutorial-step-title {
      order: 3
    }
    &.show-full-description {
      cursor: pointer;
    }
    .sd-button.sd-button_icon_lt_sm.show-full-description__toggle {
      order: 1;
      position: absolute;
      top: 0;
      left: 0;
      transform: translate(-6px, calc(-100% - 6px));
      display: none;
      transform-origin: center center;
      zoom: 0;
      will-change: zoom;
      transition: zoom 0.33s ease-in-out;
      mix-blend-mode: normal;
    }
    @media all and (max-width: #{$sd-vw_sm - 1}) {
      .sd-button.sd-button_icon_lt_sm.show-full-description__toggle {
        display: flex;
        background: white;
        .feather {
          stroke: map_get($colors, black);
        }
        margin: 0 12px 0 0;
        zoom: 1;
        &:hover, &:focus, &:active {
          mix-blend-mode: normal;
          background: goldenrod;
          .feather {
            stroke: map_get($colors, white);
          }
        }
      }
    }
    @media all and (min-width: $sd-vw_sm) {
      padding-bottom: 24px;
    }
  }

  .sd-product-manual__interactive-product {
    flex: 1 1 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: stretch;
    align-items: flex-start;
    width: 100%;
    max-height: 80vh;
    padding: 0;
    transform: translateY(-6px);
    zoom: 1.5;
    overflow: visible;
    @media all and (max-width: #{$sd-vw_sm - 1}) and (orientation: portrait) {
      max-height: 50vh;
    }
    @media all and (min-width: $sd-vw_sm) {
      position: static;
      top: unset;
      zoom: unset;
      transform: none;
      padding-left: 0;
      max-height: calc(100vh - 88px - 96px - 76px);
      align-self: stretch;
      margin-top: -36px;
    }
    @media all and (min-width: $sd-vw_md),
    all and (max-height: $sd-vw_md) {
      flex: 1 0 calc(200% / 3);
    }
  }
  .sd-product-manual .sd-product-manual__interactive-product {
    z-index: 0;
    background: none;
    box-shadow: none;
    .disabled {
      pointer-events: none;
      user-select: none;
      circle.highlight {
        fill: map_get($colors, grey);
      }
    }
    @media all and (max-width: #{$sd-vw_sm - 1}) {
      height: inherit;
      max-height: unset;
      margin: 0;
      transform-origin: center center;
      transform: translateY(0vh);
      zoom: 0.88;
    }
  }
  .sd-product-manual__product-values {
    z-index: 1;
    flex: 0 0 auto;
    align-self: flex-end;
    min-height: 6em;
    width: 100%;
    padding-top: 36px;
    padding-left: 36px;
    margin-left: 24px;
    display: none;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: stretch;
    text-align: right;
    .product-value {
      flex: 0 0 calc(100% / 3);
      padding: 18px 0 0 18px;
      width: auto;
      min-height: 5em;
      border-top: 1px solid map_get($colors, black);
      &:first-of-type {
        padding-bottom: 0;
      }
      h6 + p {
        margin-top: 6px;
      }
    }
    @media all and (min-width: $sd-vw_sm) {
      display: flex;
    }
    @media all and (min-width: $sd-vw_md) {
      flex: 0 1 calc(100% / 3);
      flex-flow: column-reverse nowrap;
      padding-top: 0;
      padding-left: 0;
      max-width: 10em;
      .product-value {
        flex: 0 0 auto;
        padding: 18px 0;
        width: 100%;
      }
    }
  }

  .tutorial-title {
    z-index: 2;
    flex: 1 1 100%;
    margin: -24px -12px 0;
    padding: 24px 12px 12px;
    align-self: stretch;
    position: sticky;
    top: 0;
    display: inline-flex;
    justify-content: space-between;
    align-items: baseline;
    h2 {
      line-height: 1;
      margin-left: 18px;
      margin-bottom: 12px;
    }
    @media all and (max-width: #{$sd-vw_sm - 1}) {
      flex-flow: column;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      padding: 24px 24px 0;
      margin: 0;
      h2 {
        order: 2;
        flex: 1 1 calc((100% / 3) - 4px);
        margin-left: 0;
        margin-bottom: 0;
        font-size: 7vmin;
        line-height: 30px;
        text-align: right;
      }
      .tutorial-subtitle {
        order: 1;
        margin: 0;
      }
      .tutorial-subtitle > * {
        line-height: 15px;
      }
    }
    @media all and (min-width: $sd-vw_sm) {
      flex: 0 0 calc(40% - 18px);
      grid-row: 1 / 2;
      grid-column: 1 / -1;
      margin: unset;
      padding: unset;
      align-self: unset;
      position: unset;
      top: unset;
      display: unset;
      justify-content: unset;
      h2 {
        margin-left: unset;
      }
    }
  }
  .tutorial-subtitle {
    display: inline;
    word-break: break-word;
    line-height: 1;
    & > * {
      width: auto;
      margin-right: 0;
      font-size: 12px;
    }
    @media all and (min-width: $sd-vw_sm) {
      display: block;
      & > * {
        margin-right: 18px;
        font-size: unset;
      }
    }
  }
  .tutorial-title h2,
  .tutorial-subtitle > * {
    display: inline;
  }

  .sd-product-manual__content-actions {
    flex: 1 1 100%;
    z-index: 2;
    align-self: stretch;
    order: 2;
    position: absolute;
    top: 0;
    left: 12px;
    right: 12px;
    padding-top: 12px;
    margin-top: 4em;
    .sd-button-group {
      flex-flow: row nowrap;
      justify-content: stretch;
      align-items: stretch;
    }
    button.sd-button.tutorial-button {
      flex: 1 1 50%;
      min-width: 0;
      margin-top: 1ex;
    }
    @media all and (max-width: #{$sd-vw_sm - 1}) {
      z-index: 1;
      left: 0;
      right: 0;
      margin-top: 0;
      background: map_get($colors, white);
    }
    @media all and (min-width: $sd-vw_sm) {
      order: unset;
      position: relative;
      left: unset;
      right: unset;
      bottom: unset;
      flex: 0 0 auto;
      grid-row: 1 / 3;
      grid-column: -2 / -1;
      align-self: flex-end;
      button.sd-button.tutorial-button {
        flex: 0 0 auto;
      }
      .sd-button-group {
        flex-flow: row wrap;
        justify-content: flex-end;
      }
    }
  }
  .sd-product-manual > .sd-product-manual__content-actions {
    @media all and (max-width: #{$sd-vw_sm - 1}) {
      margin: -24px -24px 0;
      padding: 6px 12px;
    }
  }

  svg.manual-preview,
  svg.sd-product-model {
    display: block;
    width: inherit;
    height: auto;
  }
  svg.sd-product-model {
    flex: 1 1 100%;
    max-height: 75vh;
  }
  [id^="Crown_"],
  [id^="Pusher-"] {
    cursor: pointer;
  }
  .highlight {
    cursor: pointer;
    user-select: none;
    pointer-events: all;
    mix-blend-mode: multiply;
    @supports not (mix-blend-mode: multiply) {
      fill: rgba(20, 10, 5, 0.6);
      & ~ foreignObject .crownText {
        transition: fill 0.24s ease-in-out;
      }
      &[opacity="0.5"] ~ foreignObject .crownText,
      &[opacity="1"] ~ foreignObject .crownText {
        color: white;
        fill: white;
        font-weight: 500;
      }
      & ~ .arrow-line {
        transition: stroke 0.24s ease-in-out;
      }
      &[opacity="0.5"] ~ .arrow-line,
      &[opacity="1"] ~ .arrow-line {
        stroke: white;
      }
    }
  }
  .tutorial-target {
    margin: 6px 0;
    padding: 12px;
    text-align: center;
    color: map_get($colors, black);
    background: #FED594;
    h5 + p {
      margin-top: 6px;
      max-width: 100%;
    }
    @media all and (min-width: $sd-vw_sm) {
      margin: 24px 0;
      padding: 18px;
    }
  }
</style>
